// IoT / Meldezentrale — client-side status derivation from normalized MWS
// messages (see backend /api/iot). All time math uses the message epoch (UTC
// seconds) so it ticks live and is timezone-safe.

export const IOT_CATS_RE = /terrorsperre|baustromverteiler|meldepunkt/i;
export const SOS_TTL = 300; // seconds — an SOS pin pulses for 5 minutes.

// state -> visual style + short German label.
export const STATE_STYLE = {
  sos: { color: "#dc2626", pulse: true, label: "SOS-Alarm" },
  open: { color: "#dc2626", pulse: true, label: "Geöffnet" },
  closed: { color: "#16a34a", pulse: false, label: "Geschlossen" },
  expired: { color: "#94a3b8", pulse: false, label: "Abgelaufen" },
  none: { color: "#64748b", pulse: false, label: "Keine Meldung" },
};

export function durText(sec) {
  sec = Math.max(0, Math.floor(sec));
  if (sec < 60) return sec <= 1 ? "1 Sekunde" : `${sec} Sekunden`;
  const min = Math.floor(sec / 60);
  if (min < 60) return min === 1 ? "1 Minute" : `${min} Minuten`;
  const h = Math.floor(min / 60);
  if (h < 24) return h === 1 ? "1 Stunde" : `${h} Stunden`;
  const d = Math.floor(h / 24);
  return d === 1 ? "1 Tag" : `${d} Tage`;
}

export function isTerror(category) {
  return /terrorsperre/i.test(category || "");
}

// Returns { state, ref, prefix, ageText, statusText }.
export function deriveStatus(obj, nowSec) {
  const msgs = obj.messages || [];
  const latestSOS = msgs.find((m) => m.kind === "SOS" || m.alarm === 1);
  const latestPOS = msgs.find(
    (m) => m.position === "OPEN" || m.position === "CLOSED"
  );
  const sosActive = latestSOS && nowSec - latestSOS.epoch < SOS_TTL;
  const terror = isTerror(obj.category);

  let state = "none";
  let ref = null;
  if (sosActive) {
    state = "sos";
    ref = latestSOS;
  } else if (latestPOS && latestPOS.position === "OPEN") {
    state = "open";
    ref = latestPOS;
  } else if (latestPOS && latestPOS.position === "CLOSED") {
    state = "closed";
    ref = latestPOS;
  } else if (latestSOS) {
    state = "expired";
    ref = latestSOS;
  }

  let prefix = "";
  let ageText = "";
  let statusText = "";
  if (state === "none") {
    statusText = "Keine Meldungen vorhanden";
  } else if (state === "expired") {
    statusText = "Meldung abgelaufen";
  } else {
    ageText = durText(nowSec - ref.epoch);
    if (state === "sos") prefix = "SOS Meldung vor ";
    else if (state === "open") prefix = terror ? "Terrorsperre geöffnet seit " : "Geöffnet seit ";
    else if (state === "closed") prefix = terror ? "Terrorsperre geschlossen seit " : "Geschlossen seit ";
    statusText = prefix + ageText;
  }

  return { state, ref, prefix, ageText, statusText };
}
